import React from 'react';
import { observer } from 'mobx-react';
import {
    CheckboxInput,
    MultiSelectInput,
    TextInput,
} from '@awarego-ui/components';
import { Box, Checkbox, Chip, MenuItem } from '@mui/material';

export const WEBHOOK_TYPE_OPTIONS = [
    { id: 'hra-insights-completion', name: 'HRA Insights Completion' },
    { id: 'training-completion', name: 'Training Completion' },
    { id: 'assessment-completion', name: 'Assessment Completion' },
];

// Webhook dialog fields, mirroring ReportSetupFormFragment: the types
// multiselect works exactly like the report's employee-lists multiselect and
// the "All webhook types" checkbox disables it, like "Select all employee
// lists" does.
function WebhookFormFields({ form, companies }) {
    const inputHasError = (input) =>
        form.$(input).error && form.$(input).error.length > 0;

    const getTypeName = (id) => {
        const type = WEBHOOK_TYPE_OPTIONS.find((item) => item.id === id);

        return type ? type.name : '';
    };

    return (
        <>
            <TextInput
                error={inputHasError('name')}
                helperText={
                    inputHasError('name')
                        ? 'Please enter name for the webhook'
                        : undefined
                }
                stretched
                {...form.$('name').bind()}
            />
            <TextInput
                error={inputHasError('url')}
                helperText={
                    inputHasError('url')
                        ? 'Enter a valid webhook URL starting with https://'
                        : undefined
                }
                stretched
                {...form.$('url').bind()}
            />
            <TextInput stretched {...form.$('signatureSecret').bind()} />
            {form.has('company') && (
                <TextInput select stretched {...form.$('company').bind()}>
                    <MenuItem value="all">All companies</MenuItem>
                    {(companies || []).map((c) => (
                        <MenuItem key={c.id} value={String(c.id)}>
                            {c.name}
                        </MenuItem>
                    ))}
                </TextInput>
            )}
            <MultiSelectInput
                error={inputHasError('types')}
                helperText={
                    inputHasError('types')
                        ? 'Please select at least one webhook type'
                        : undefined
                }
                inline
                renderValue={(selected) => {
                    if (selected.length === 0) {
                        return <em>Select from existing types</em>;
                    } else {
                        return (
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 0.5,
                                }}
                            >
                                {selected &&
                                    selected.map((value) => (
                                        <Chip
                                            key={value}
                                            label={getTypeName(value)}
                                            disabled={form.$('allTypes').value}
                                        />
                                    ))}
                            </Box>
                        );
                    }
                }}
                {...form.$('types').bind()}
            >
                {WEBHOOK_TYPE_OPTIONS.map((type) => (
                    <MenuItem
                        disableRipple
                        key={type.id}
                        value={type.id}
                        style={{
                            paddingTop: '0px',
                            paddingBottom: '0px',
                        }}
                    >
                        <Checkbox
                            checked={
                                form.$('types').bind().value.indexOf(type.id) >
                                -1
                            }
                            disableRipple
                            color="primary"
                        />
                        {type.name}
                    </MenuItem>
                ))}
            </MultiSelectInput>
            <CheckboxInput
                disableRipple
                error={inputHasError('allTypes')}
                {...form.$('allTypes').bind()}
            />
            <CheckboxInput disableRipple {...form.$('enabled').bind()} />
        </>
    );
}

export default observer(WebhookFormFields);
